export default __webpack_public_path__ + "images/ghost_8f1e82.svg";